export default "__VITE_ASSET__BblY6nf7__"